var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNameInputIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3327 13C11.3327 12.0696 11.3327 11.6044 11.2179 11.2259C10.9593 10.3736 10.2924 9.70669 9.44011 9.44816C9.06158 9.33333 8.59639 9.33333 7.66601 9.33333H4.33269C3.40231 9.33333 2.93712 9.33333 2.55859 9.44816C1.70632 9.70669 1.03938 10.3736 0.780842 11.2259C0.666016 11.6044 0.666016 12.0696 0.666016 13M8.99935 4C8.99935 5.65685 7.6562 7 5.99935 7C4.34249 7 2.99935 5.65685 2.99935 4C2.99935 2.34315 4.34249 1 5.99935 1C7.6562 1 8.99935 2.34315 8.99935 4Z",
    stroke: "#0A0A0A",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameInputIcon);
export default __webpack_public_path__ + "static/media/nameInputIcon.7569649364de9fb39e0cf65d7a0467c9.svg";
export { ForwardRef as ReactComponent };